import { all } from 'redux-saga/effects';

import authSagas from './auth/sagas';
import usersSagas from './users/sagas';
import languagesSagas from './languages/sagas';
import missionsSagas from './missions/sagas';
import additionalStagesSagas from './additionalStages/sagas';
import additionalExercisesSagas from './additionalExercises/sagas';
import exercisesSagas from './exercises/sagas';
import tasksSagas from './tasks/sagas';
import rewardsSagas from './rewards/sagas';
import taskTypesSagas from './taskTypes/sagas';
import documentsSagas from './documents/sagas';
import coachSagas from './coach/sagas';
import meetingsSagas from './meetings/sagas';
import chatScheduleSagas from './chatSchedule/sagas';

export function* rootSaga() {
    yield all([
        ...authSagas,
        ...usersSagas,
        ...languagesSagas,
        ...missionsSagas,
        ...additionalStagesSagas,
        ...exercisesSagas,
        ...tasksSagas,
        ...additionalExercisesSagas,
        ...rewardsSagas,
        ...taskTypesSagas,
        ...documentsSagas,
        ...coachSagas,
        ...meetingsSagas,
        ...chatScheduleSagas,
    ]);
}
